export enum PORTAL_LICENSE_TYPE {
  TRIAL = 'trial',
  PAID = 'paid',
}

export enum PORTAL_LICENSE_STATE {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
}

export interface PortalLicense {
  type: PORTAL_LICENSE_TYPE
  expiresAt: string
  createdAt?: string
  state: PORTAL_LICENSE_STATE
}
